import { useQuery } from '@apollo/client';
import {
  NodeViewContent,
  NodeViewWrapper,
  type NodeViewProps,
} from '@tiptap/react';
import { useEffect } from 'react';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { Player } from '@xing-com/crate-video-player';
import { IconTrash } from '@xing-com/icons';
import { zIndexStickyLayer3 } from '@xing-com/layout-tokens';
import { ProgressBar } from '@xing-com/progress-bar';
import { spaceM } from '@xing-com/tokens';

import { GetTiptapVideoStatusDocument } from './get-tiptap-video-status.gql-types';

const StyledButton = styled(Button)`
  position: absolute;
  right: ${spaceM};
  top: ${spaceM};
  z-index: ${zIndexStickyLayer3};
`;
const StyledNodeViewWrapper = styled(NodeViewWrapper)`
  position: relative;
`;

const StyledProgressBar = styled(ProgressBar)`
  width: 75%;
  margin: 0 auto;
  padding: 0;
`;

export const XingVideoView: React.FC<NodeViewProps> = ({
  node,
  editor,
  deleteNode,
}) => {
  const { data, loading, refetch } = useQuery(GetTiptapVideoStatusDocument, {
    variables: { ref: node.attrs.videoRef },
  });
  const isUploading = loading || data?.videoV2?.status === 'CREATED';

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isUploading) {
        refetch();
      } else {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [isUploading, refetch]);

  return (
    <StyledNodeViewWrapper className="react-component">
      {editor.isEditable && !isUploading && (
        <StyledButton
          icon={IconTrash}
          size="medium"
          variant="tertiary"
          onClick={deleteNode}
        />
      )}
      {isUploading && <StyledProgressBar variant="indeterminate" />}
      {!isUploading && <Player id={node.attrs.videoRef} section="article" />}
      <NodeViewContent className="xing-video-content" />
    </StyledNodeViewWrapper>
  );
};
